<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">공개강좌</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="right-title">
          <div class="right-title__left">
            <div class="type-wrap">
              <SeminarIcon />
              {{ seminar.typeName }}
            </div>
            <div class="title-wrap">
              <div class="is-18r">{{ seminar.title }}</div>
            </div>
            <div class="title-info">
              <div class="calender">
                <calender-icon />
                {{ seminar.term }}
              </div>
              <div class="hour">
                <clock-icon />
                {{ seminar.time }}
              </div>
            </div>
          </div>
          <div class="right-title__right is-14b cursor" @click="goSeminarPayment">교육참가신청</div>
        </div>
        <div v-if="seminar.status === '01'">
          <div class="detail-subject">교육목적</div>
          <div class="purpose" v-html="seminar.purpose" />
          <div class="detail-subject">교육대상</div>
          <div class="target">
            {{ seminar.target }}
          </div>
          <div class="detail-subject">교육장소(클릭하시면 약도보기로 이동합니다)</div>
          <div class="place" @click="openPlaceMap(seminar.placeLink)">{{ seminar.place }}</div>
          <div class="detail-subject" style="margin-bottom: 24px">교육내용</div>
          <div class="info-wrap">
            <div v-for="info in seminar.info" :key="'info' + info.id" class="info-item">
              <div class="info-title is-16b text-blue-500">{{ info.title }}</div>
              <div class="info-info__wrap">
                <div v-if="info.term" class="is-12m info-term">
                  <calender-icon />
                  {{ info.term }}
                </div>
                <div v-if="info.position || info.instructor || info.profile" class="info-profile">
                  <person-icon />
                  <div class="is-12m">{{ info.position }}</div>
                  <div class="is-12m">{{ info.instructor }}</div>
                  <div class="is-12m">{{ info.profile }}</div>
                </div>
              </div>
              <div class="info-content" v-html="info.content" />
            </div>
          </div>
          <div v-if="seminar.etcShow">
            <div class="detail-subject">{{ seminar.etcTitle }}</div>
            <div class="purpose" v-html="seminar.etcContent"/>
          </div>
          <div class="detail-subject" style="margin-bottom: 24px">참가비</div>
          <div class="info-price__wrap">
            <div class="wrap-title">
              <div class="is-14m">구분</div>
              <div class="is-14m">1사 1인</div>
              <div class="is-14m">1사 2인</div>
              <div class="is-14m">비고</div>
            </div>
            <div class="wrap-item">
              <div class="item">
                <div class="is-14r">비회원사</div>
                <div class="is-14r">{{ seminar.price.normal['1'] }}</div>
                <div class="is-14r">{{ seminar.price.normal['2'] }}</div>
                <div class="is-14r">부가세, 교재대 및<br />중식대 포함</div>
              </div>
              <div class="item">
                <div class="is-14r">회원사</div>
                <div class="is-14r">{{ seminar.price.member['1'] }}</div>
                <div class="is-14r">{{ seminar.price.member['2'] }}</div>
                <div class="is-14r">부가세, 교재대 및<br />중식대 포함</div>
              </div>
            </div>
          </div>
          <div class="detail-subject">교육과정 문의</div>
          <div class="purpose" style="margin-bottom: 24px">
            <div class="qna-tel is-14r"><strong>TEL</strong> : {{ seminar.managerTel }}</div>
            <!--            <div class="qna-fax is-14r"><strong>FAX</strong> : {{ seminar.managerFax }}</div>-->
            <div class="qna-name is-14r"><strong>담당자</strong> : {{ seminar.managerName }}</div>
          </div>
          <div class="supply-btn" @click="goSeminarPayment" style="margin-bottom: 24px">교육참가신청</div>
        </div>
        <div>
          <div class="top-navi">
            <div
              v-for="(item, index) in navItem"
              :key="'topNavi' + index"
              :class="['top-navi__item', {selected: item.selected}]"
              @click="onClickNavItem(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="search-wrap">
            <input
              type="text"
              :value="seminarSearchInfo.keyword"
              @input="seminarSearchInfo.keyword = $event.target.value"
              placeholder="검색"
              @keyup.enter="getSeminarList"
            />
            <search-icon class="search-icon" @click="getSeminarList" />
          </div>
          <div class="plan-table">
            <div class="plan-table__top">
              <div class="top-item">분야</div>
              <div class="top-item">상태</div>
              <div class="top-item">주제</div>
              <div class="top-item">교육기간</div>
            </div>
            <div class="plan-table__list">
              <div
                :class="['plan-table__item', {active: item.id === seminar.id}]"
                v-for="(item, index) in seminarListForPlan"
                :key="'planTable' + index"
                @click="goDetailPage(item)"
              >
                <div class="table-item">{{ item.typeName }}</div>
                <div class="table-item text-blue-500">{{ item.statusName }}</div>
                <div class="table-item" :class="{'font-bold': item.status === '01'}">{{ item.title }}</div>
                <div class="table-item">{{ item.term }}</div>
              </div>
            </div>
          </div>
          <Pagination
            :total-count="seminarSearchInfo.totalCount"
            :now-page="seminarSearchInfo.page"
            :limit="seminarSearchInfo.limit"
            @changePage="listChangePage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {useSeminarStore} from '~/store/seminar/index.js'
import {useMembershipStore} from '~/store/membership'
import {useMemberStore} from '~/store/member/index.js'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import SeminarIcon from 'assets/svg/Seminar-Icon.vue'
import CalenderIcon from 'assets/svg/calender-icon.vue'
import ClockIcon from 'assets/svg/clock-icon.vue'
import PersonIcon from 'assets/svg/person-icon.vue'
import Pagination from '~/components/common/Pagination.vue'
import SearchIcon from 'assets/svg/search-icon.vue'

export default {
  name: 'SeminarId',
  components: {SearchIcon, Pagination, PersonIcon, ClockIcon, CalenderIcon, BreadCrumb, SeminarIcon},
  setup() {
    const store = useSeminarStore()
    const memberStore = useMemberStore()
    const membershipStore = useMembershipStore()
    return {store, memberStore, membershipStore}
  },
  data() {
    return {
      isAuth: false,
      seminarId: null,
      breadCrumb: ['홈', '공개강좌', '교육과정', '교육참가 신청'],
      menuList: [
        {
          name: '교육과정',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '월간교육일정표', selected: false},
            {name: '연간교육일정표', selected: false}
          ]
        },
        {
          name: '접수중 교육과정',
          selected: false,
          subMenuShow: true,
          subMenu: [
            {name: '교육참가 신청', selected: false},
            {name: '종료된 교육과정', selected: false},
            {name: '수강내역 및 수료증 출력', selected: false}
          ]
        },
        {
          name: '교육장 안내',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '교육장 안내', selected: false}]
        },
        {
          name: '교육신청 방법',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '교육신청 방법', selected: false},
            {name: '교육안내문 신청', selected: false}
          ]
        }
      ],
      seminar: {
        id: 0,
        type: '',
        typeName: '',
        status: '',
        title: '',
        time: '',
        purpose: '',
        target: '',
        place: '',
        placeLink: '',
        etcTitle: '',
        etcContent: '',
        etcShow: true,
        isAvailable: false,
        price: {
          member: {
            1: '',
            2: ''
          },
          normal: {
            1: '',
            2: ''
          }
        },
        priceInfo: {
          normal: {
            1: {
              supplyPrice: 0,
              vat: 0
            },
            2: {
              supplyPrice: 0,
              vat: 0
            }
          },
          member: {
            1: {
              supplyPrice: 0,
              vat: 0
            },
            2: {
              supplyPrice: 0,
              vat: 0
            }
          }
        },
        managerName: '',
        managerTel: '',
        managerFax: '',
        term: '',
        info: [
          {
            id: 0,
            title: '',
            content: null,
            instructor: null,
            position: null,
            profile: null,
            term: ''
          }
        ]
      },
      seminarListForPlan: [
        {
          id: 0,
          typeName: '',
          title: '',
          term: ''
        }
      ],
      seminarSearchInfo: {
        type: '',
        page: 1,
        pageType: '1',
        limit: 10,
        totalCount: 0,
        keyword: ''
      },
      navItem: [
        {
          name: '전체과정',
          selected: false,
          type: ''
        },
        {
          name: '인사',
          selected: false,
          type: 'SMT01'
        },
        {
          name: '노무',
          selected: false,
          type: 'SMT02'
        },
        {
          name: 'HRD',
          selected: false,
          type: 'SMT03'
        },
        {
          name: '기타',
          selected: false,
          type: 'SMT04'
        }
      ]
    }
  },
  created() {
    this.seminarId = this.$route.params.seminarId
  },
  async mounted() {
    this.setQueryData()
    this.isAuth = this.memberStore.isAuthenticated
    await this.getSeminarDetail()
    await this.getSeminarList()
    this.submenuActive()
  },
  methods: {
    submenuActive(){
      const pageType = this.seminarSearchInfo.pageType;
      // menuList에서 submenu selected 처리
      if ( pageType === '1' ){
        this.menuList[1].subMenu[0].selected = true
      } else if ( pageType === '2'){
        this.menuList[1].subMenu[1].selected = true
      }
    },
    setQueryData() {
      this.seminarSearchInfo.type = this.$route.query.type || ''
      this.seminarSearchInfo.page = Number(this.$route.query.page) || 1
      this.seminarSearchInfo.keyword = this.$route.query.keyword || ''
      this.seminarSearchInfo.pageType = this.$route.query.pageType || '1'

      // navItem의 selected 상태를 초기화
      this.navItem.forEach(item => {
        item.selected = item.type === this.seminarSearchInfo.type;
      })
    },
    async goSeminarPayment() {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }
      if (this.seminar.isAvailable) {
        // 회원사업 구독여부 체크해서 alert
        const {data} = await this.store.getSeminarDiscount()
        const isDiscount = data.isDiscount
        if (isDiscount) {
          const userId = this.memberStore.member.userId
          const alertMessage = `ID : ${userId}님의\n소속회사는 한국인사관리협회의 "회원사"로 교육비 할인이 적용되었습니다.\n\n * 회원사란 한국인사관리협회의 월례미팅\n(한국인사관리자, 교육연수담당자, 팀/부장 교류회, CHO포럼)중 하나 이상 가입된 회사입니다.`
          alert(alertMessage)
        }
        this.$router.push(`/seminar/payment?seminarId=${this.seminarId}`)
      } else {
        alert('지금은 신청할 수 없습니다.')
      }
    },
    goDetailPage(item) {
      this.$router.push(
        `/seminar/${item.id}?type=${this.seminarSearchInfo.type}&keyword=${this.seminarSearchInfo.keyword}&page=${this.seminarSearchInfo.page}&pageType=${this.seminarSearchInfo.pageType}`
      )
    },
    onClickNavItem(item) {
      this.navItem.forEach(navItem => {
        navItem.selected = false
      })
      item.selected = true
      this.seminarSearchInfo.type = item.type
      this.seminarSearchInfo.page = 1
      this.getSeminarList()
    },
    listChangePage(page) {
      this.seminarSearchInfo.page = page
      this.getSeminarList()
    },
    openPlaceMap(url) {
      if (url) {
        window.open(url)
      }
    },
    async getSeminarList() {
      try {
        const {data} = await this.store.getSeminarList(this.seminarSearchInfo)
        this.seminarListForPlan = data.list
        this.seminarSearchInfo.totalCount = data.count
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    async getSeminarDetail() {
      try {
        const {data} = await this.store.getSeminarDetail(this.seminarId)
        this.seminar = data.seminar
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/seminar?menu=0&subMenu=0')
          break
        case 1:
          this.$router.push('/seminar?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/seminar?menu=2&subMenu=0')
          break
        case 3:
          this.$router.push('/seminar?menu=3&subMenu=0')
          break
      }
      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      if (idx === 2) {
        if (!this.isAuth) {
          alert('로그인 후 이용 가능합니다.')
          return
        }
      }

      this.$router.push(`/seminar?menu=${index}&subMenu=${idx}`)

      window.scrollTo({top: 0})
    }
  }
}
</script>

<style scoped lang="scss">
.detail-subject {
  padding: 12px 0px;
  border-bottom: 2px solid #0058aa;
  color: #0058aa;
  font-family: 'Godo', sans-serif;
  font-size: 18px;
  font-weight: 700;
}

.search-wrap {
  padding: 9px;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  input {
    border: none;
    width: 100%;
    outline: none;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 17.5px */
    &::placeholder {
      color: #bdbdbd;
    }
  }

  .search-icon {
    cursor: pointer;
  }
}

.default-container {
  padding: 48px 0 100px;

  .content {
    display: flex;
    gap: 24px;
    position: relative;

    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;

      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }

      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }

      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }

        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }

        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }

    .content-right {
      width: 100%;

      .right-title {
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        background: #f8fbfd;
        padding: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        .right-title__left {
          .type-wrap {
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            display: flex;
            gap: 8px;
            align-items: center;
            margin-bottom: 8px;
          }

          .title-wrap {
            margin-bottom: 4px;

            .is-18r {
              color: #0064b1;
              font-family: Godo;
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: 125%; /* 22.5px */
            }
          }

          .title-info {
            display: flex;
            gap: 8px;

            .calender {
              display: flex;
              gap: 4px;
              color: #606060;
              font-family: Pretendard;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 125%; /* 15px */
            }

            .hour {
              display: flex;
              gap: 4px;
              color: #606060;
              font-family: Pretendard;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 125%;
            }
          }
        }

        .right-title__right {
          border-radius: 4px;
          background: #0058aa;
          display: inline-flex;
          padding: 8px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          color: #fff;
          height: 34px;
        }
      }

      .purpose {
        white-space: pre-line;
        padding: 24px;
        font-size: 14px;
        font-weight: 400;
      }

      .target {
        white-space: pre-line;
        padding: 24px;
        font-size: 14px;
        font-weight: 400;
      }

      .place {
        white-space: pre-line;
        padding: 24px;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .info-wrap {
        margin-bottom: 24px;

        .info-item {
          border-radius: 0px 0px 4px 4px;
          border-right: 1px solid #dbdbdb;
          border-bottom: 1px solid #dbdbdb;
          border-left: 1px solid #dbdbdb;
          background: #fff;
          padding: 24px;
          margin-bottom: 16px;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            top: -5px;
            left: -1px;
            right: 0;
            height: 6px;
            width: 100.3%;
            background: #b9ddf9;
            clip-path: polygon(0.4% 0, 99% 0, 100% 100%, 0 100%);
          }

          .info-title {
            margin-bottom: 12px;
          }

          .info-info__wrap {
            display: flex;
            gap: 16px;
            align-items: flex-start;
            margin-top: 12px;

            .info-term {
              display: flex;
              align-items: center;
              color: #606060;
              gap: 4px;
              white-space: nowrap;
            }

            .info-profile {
              display: flex;
              gap: 4px;
              flex-wrap: wrap;

              .is-12m {
                color: #606060;
                word-break: keep-all;
              }
            }
          }

          .info-content {
            margin-top: 12px;
            white-space: pre-line;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }

      .info-price__wrap {
        border: 1px solid #dbdbdb;

        .wrap-title {
          background: #fbfbfb;
          height: 48px;
          display: flex;

          .is-14m {
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #dbdbdb;

            &:first-child {
              width: 120px;
            }

            &:nth-child(2) {
              width: 160px;
            }

            &:nth-child(3) {
              width: 160px;
            }

            &:last-child {
              width: 273px;
              border-right: 0;
            }
          }
        }

        .wrap-item {
          .item {
            height: 48px;
            display: flex;

            &:first-child {
              border-top: 1px solid #dbdbdb;
              border-bottom: 1px solid #dbdbdb;
            }
          }

          .is-14r {
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid #dbdbdb;

            &:first-child {
              width: 120px;
            }

            &:nth-child(2) {
              width: 160px;
            }

            &:nth-child(3) {
              width: 160px;
            }

            &:last-child {
              width: 273px;
              border-right: 0;
              color: #0058aa;
              font-weight: 500;
              text-align: center;
            }
          }
        }
      }

      .supply-btn {
        display: flex;
        padding: 14px 24px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        border-radius: 4px;
        background: #0058aa;
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        cursor: pointer;
      }

      .top-navi {
        border-top: 1px solid #dbdbdb;
        border-bottom: 1px solid #dbdbdb;
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        .top-navi__item {
          padding: 18px 16px;
          color: #606060;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 125%; /* 17.5px */
          cursor: pointer;

          &:hover {
            color: #0058aa;
          }

          &.selected {
            font-weight: 700;
            color: #0058aa;
            position: relative;

            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 3px;
              background: #0058aa;
            }
          }
        }
      }

      .plan-table {
        margin-bottom: 24px;

        .plan-table__top {
          display: flex;
          border-bottom: 1px solid #909090;
          background: #fbfbfb;

          .top-item {
            padding: 12px 16px;
            font-size: 12px;
            font-weight: 500;

            &:first-child {
              width: 100px;
            }

            &:nth-child(2) {
              width: 100px;
            }

            &:nth-child(3) {
              width: 380px;
            }

            &:last-child {
              width: 170px;
            }
          }
        }

        .plan-table__list {
          .plan-table__item {
            display: flex;
            border-bottom: 1px solid #dbdbdb;
            cursor: pointer;

            &.active {
              background: #e8f0ff;
            }

            &:hover {
              background: #fbfbfb;
            }

            .table-item {
              font-size: 14px;
              padding: 16px;

              &:first-child {
                width: 100px;
              }

              &:nth-child(2) {
                width: 100px;
              }

              &:nth-child(3) {
                width: 380px;
              }

              &:last-child {
                width: 170px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
